import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import Modal from "components/Modal";
import FormikInput from "components/formik/FormikInput";
import PasswordValidator from "components/PasswordValidator";

import clientChangePasswordSchema from "libs/validations/admin/clientChangePasswordSchema";
import { useClientSettings } from "context/admin/client-settings";

const ChangePasswordModal = ({ onClose }) => {
  const { t } = useTranslation();

  const { changePassword } = useClientSettings();

  const onSubmit = async (values, setSubmitting, setErrors) => {
    try {
      await changePassword(values);
      onClose();
    } catch (err) {
      if (err?.response?.data?.type === "wrong_password") {
        setErrors({ old_password: err?.response?.data?.error });
      }
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{
        new_password: "",
        new_password2: "",
      }}
      validationSchema={clientChangePasswordSchema}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        onSubmit(values, setSubmitting, setErrors);
      }}
    >
      {({ values, isSubmitting, submitForm }) => (
        <Form autoComplete="off">
          <Modal
            title={t("Change password")}
            onClose={onClose}
            onSubmit={submitForm}
            loading={isSubmitting}
          >
            <div className="form">
              <FormikInput
                name="new_password"
                label={t("New password")}
                type="password"
                placeholder="****************"
                disabled={isSubmitting}
              />
              <FormikInput
                name="new_password2"
                label={t("Repeat new password")}
                placeholder="****************"
                type="password"
                disabled={isSubmitting}
              />
              <PasswordValidator password={values?.new_password} />
            </div>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};

export default ChangePasswordModal;
